(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('organo', {
            parent: 'entity',
            url: '/organo?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.organo.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/organo/organos.html',
                    controller: 'OrganoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('organo-detail', {
            parent: 'organo',
            url: '/organo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.organo.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/organo/organo-detail.html',
                    controller: 'OrganoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('organo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Organo', function($stateParams, Organo) {
                    return Organo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'organo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('organo-detail.edit', {
            parent: 'organo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo/organo-dialog.html',
                    controller: 'OrganoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Organo', function(Organo) {
                            return Organo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organo.new', {
            parent: 'organo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo/organo-dialog.html',
                    controller: 'OrganoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                nombreUnificado: null,
                                esVisible: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('organo', null, { reload: 'organo' });
                }, function() {
                    $state.go('organo');
                });
            }]
        })
        .state('organo.edit', {
            parent: 'organo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo/organo-dialog.html',
                    controller: 'OrganoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Organo', function(Organo) {
                            return Organo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organo', null, { reload: 'organo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('organo.delete', {
            parent: 'organo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/organo/organo-delete-dialog.html',
                    controller: 'OrganoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Organo', function(Organo) {
                            return Organo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('organo', null, { reload: 'organo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
